// LCH theme utilities — single source of truth for light/dark.
export const THEME_STORAGE_KEY = "lch-theme";

export function getSystemTheme() {
  if (typeof window === "undefined" || !window.matchMedia) return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function getInitialTheme() {
  try {
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch (e) {
    /* ignore */
  }
  return getSystemTheme();
}

// Applies theme to <html>: data-theme drives LCH brand tokens; .dark drives shadcn tokens.
export function applyTheme(theme) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.setAttribute("data-theme", theme);
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}

// Persist a manual override and apply it immediately.
export function persistTheme(theme) {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (e) {
    /* ignore */
  }
  applyTheme(theme);
}
